<div style="text-align: center">
  <img [src]="imageUrl" alt="Workflow image" i18n-alt="@@workflow-workflow_image" />
</div>
